import { render } from "./UserUpcomingVisits.vue?vue&type=template&id=64b46c14"
import script from "./UserUpcomingVisits.vue?vue&type=script&lang=js"
export * from "./UserUpcomingVisits.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__